import { ConversationInsightsSchema } from "@redotech/redo-model/conversation-insights";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const regenerateConversationInsights = {
  name: "regenerateConversationInsights" as const,
  input: z.object({ conversationId: zExt.objectId(), teamId: zExt.objectId() }),
  output: z.object({
    success: z.boolean(),
    conversationInsights: ConversationInsightsSchema.optional(),
  }),
};
